import { AnyAction } from "redux";
import {
  REQUEST_POST_RATING,
  REQUEST_POST_RATING_ERROR,
  REQUEST_POST_RATING_SUCCESS,
  RESET_RATING,
} from "redux/actions/general/rating";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET_RATING:
      return {
        ...defaultState,
      };
    case REQUEST_POST_RATING:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_POST_RATING_SUCCESS:
      return {
        data: action.data,
        error: null,
        loading: false,
      };
    case REQUEST_POST_RATING_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
